export default __webpack_public_path__ + "static/media/marketingColor.53dc5e4b.png";